import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,
    alignItems: 'center',
    width: 'fit-content',
  },
  wrapper: {
    width: '400px',
    height: '400px',
    borderRadius: '10px',
    overflow: 'hidden',

    [theme.breakpoints.down('tablet')]: {
      marginLeft: 'auto',
      marginRight: 'auto',

      maxWidth: 'calc(100vw - 40px)',
      maxHeight: 'calc(100vw - 40px)',
    },
  },
  navWrapper: {
    width: 'fit-content',

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,
  },
  countSkeleton: {
    '&&': {
      width: 14,
      display: 'inline-flex',
    },
  },
  countLink: {
    '&&': {
      '& span': {
        display: 'inline-flex',
        textDecoration: 'none',
      },
    },
  },
}))
